import React, { useState } from 'react'
import { useDataProvider, useNotify } from 'react-admin'
import { Box, Typography, Button, CircularProgress } from '@mui/material'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

const CustomAttachmentField = ({ label, attachmentPath, loading = false }) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const [isLoading, setIsLoading] = useState(false)

  const handleOpenAttachment = async () => {
    if (!attachmentPath) {
      notify('No attachment path available', { type: 'warning' })
      return
    }

    setIsLoading(true)
    try {
      // Call the pre-signed URL API similar to audio files
      const response = await dataProvider.create('ai-books/get-signed-url', {
        data: { attachmentPath },
      })

      if (response.data && response.data.signedUrl) {
        // Open the PDF in a new tab
        window.open(response.data.signedUrl, '_blank')
      } else {
        notify('Failed to get signed URL for attachment', { type: 'error' })
      }
    } catch (error) {
      console.error('Error getting signed URL for attachment:', error)
      notify('Error opening attachment', { type: 'error' })
    } finally {
      setIsLoading(false)
    }
  }

  if (loading || !attachmentPath) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
        <AttachFileIcon color="disabled" />
        <Typography variant="body2" color="text.secondary">
          {label}: {loading ? 'Loading...' : 'No attachment available'}
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
      <AttachFileIcon color="primary" />
      <Typography variant="body2" sx={{ flexGrow: 1 }}>
        {label}:
      </Typography>
      <Button
        variant="outlined"
        size="small"
        startIcon={
          isLoading ? <CircularProgress size={16} /> : <OpenInNewIcon />
        }
        onClick={handleOpenAttachment}
        disabled={isLoading}
        sx={{ minWidth: 120 }}>
        {isLoading ? 'Opening...' : 'View PDF'}
      </Button>
    </Box>
  )
}

export default CustomAttachmentField
